(function($) {$.fn.inviewClass = function(options){var settings = $.extend({className: 'is-inview', secondClassName: 'is-inview-done', visibleOffset: 200, secondClassInterval: 1000 }, options); var isDisabled = false; if(settings.SecondClassName === ''){isDisabled = true; } return this.each(function(){var $this = $(this); function inviewClass(){let currentPos = pageYOffset; if(currentPos > $this.offset().top - window.innerHeight + settings.visibleOffset){if(!$this.hasClass(settings.className)){$this.addClass(settings.className); if(!isDisabled){var thisTimeoutID = setTimeout(function(){$this.addClass(settings.secondClassName); clearTimeout(thisTimeoutID); }, settings.secondClassInterval); } } } } inviewClass(); $(window).on('resize', function(){inviewClass(); }); $(window).on('scroll', function(){inviewClass(); }); }) } })(jQuery);

const mycom = [];
mycom.body = document.querySelector('body');
mycom.wrapper = document.querySelector('.l-main');
mycom.header = document.querySelector('.siteheader');
//mycom.container = mycom.wrapper.lastElementChild;
mycom.container = document.querySelector('.l-main');
mycom.breakPoint = 600;
mycom.headerNav = document.querySelector('.siteheader__nav');
mycom.footer = document.querySelector('.sitefooter');
mycom.anchorTarget = false;
mycom.newsArchveLoadedTime = 0;


mycom.initInviewClass = function(){

  setTimeout(()=> {
    $('.js-inview').inviewClass({
      visibleOffset: 80,
      secondClassInterval: 1000
    });
  }, 30);

  $('.js-inview-slidein').inviewClass({
    visibleOffset: 100,
    secondClassInterval: 1000
  });

}
mycom.initInviewClass();





mycom.anchorTo = (targetID, callback) => {

  if(!targetID){
    return;
  }

  let $target = mycom.container.querySelector('#' + targetID),
      waitTime = 0,
      thisOffset = -60;

  if(targetID == 'hero'){
    thisOffset = $('#hero').offset().top * -1;
  }

  if(window.innerWidth < mycom.breakPoint){
    //thisOffset = -64;
  }


  $.Velocity($target, 'scroll', {
    duration: 600,
    easing: "easeInOutCubic",
    offset: thisOffset,
    delay: waitTime,
    complete: ()=> {
      if(callback){
        callback();
      }
      mycom.anchorTarget = false;
    }
  })
}


mycom.set100vh = ()=> {

  $('.js-100vhelem').each(function(){
    const $this = $(this);

    let lastWindowWidth = window.innerWidth;

    function setSectionSize(){
      //console.log(window.innerHeight)
      const windowFitHeight = window.innerHeight;
      if(windowFitHeight < 538){
        windowFitHeight = 538;
      }
      $this.css({'height': window.innerHeight + 'px'});
    }
    setSectionSize()


    let timer = null;
    window.addEventListener('resize', ()=> {
      clearTimeout( timer );
      timer = setTimeout(function() {

        if(window.innerWidth < mycom.breakPoint){
          if(window.innerWidth !== lastWindowWidth) {
            setSectionSize()
            lastWindowWidth = window.innerWidth;
          }
        } else {
          setSectionSize()
        }

      }, 50 );
    });


  })



}
window.addEventListener('DOMContentLoaded', ()=> {
  mycom.set100vh();
})

/*
mycom.initPageTop = () => {

  if(document.querySelector('.c-pagetop') == null) {
    return;
  }

  const pageTopElem = document.querySelector('.c-pagetop'),
        topElement = document.querySelector('#barba-wrapper');

  pageTopElem.addEventListener('click', (event)=> {
    event.preventDefault();
    Velocity(topElement, 'scroll', {
      duration: 800,
      easing: "easeInOutCubic",
      offset: 0,
      delay: 0,
      complete: ()=> {
        mycom.anchorTarget = false;
      }
    })
  })
}
mycom.initPageTop();
*/

mycom.initAnchorlink = function(){

  //pagetop
  const pagetopTarget = document.querySelector('#pagetop-target');
  const pageTopArray = document.querySelectorAll('.js-pagetop');
  for(let i = 0; i < pageTopArray.length; i++){
    pageTopArray[i].addEventListener('click', (event)=> {
      event.preventDefault();
      $.Velocity(pagetopTarget, 'scroll', {
        duration: 600,
        easing: "easeInOutCubic",
      })
    })
  }


  if(mycom.body.classList.contains('home')){
    const homePageTopArray = document.querySelectorAll('.siteheader__symbol a, .sitefooter__logo');
    for(let i = 0; i < homePageTopArray.length; i++){
      homePageTopArray[i].addEventListener('click', (event)=> {
        console.log('here');
        event.preventDefault();
        mycom.anchorTo('hero');
      })
    }
  }

  const anchorLinkArray = document.querySelectorAll('.js-anchor');
  for(let i = 0; i < anchorLinkArray.length; i++) {
    const thisLink = anchorLinkArray[i];
    const target = thisLink.href.split('#')[1];

    thisLink.addEventListener('click', (event)=> {
      //console.log(target)
      event.preventDefault();
      mycom.anchorTo(target);
    })
  }


  if(location.hash){

    setTimeout(function(){
      $(window).scrollTop(0)
      const targetAnchor = location.hash.split('#')[1];
      mycom.anchorTo(targetAnchor);
    }, 50);
  }

  //クリックしたURL(hash除く)が同じならアンカー移動
  $('a').on('click', function(event){
    const $this = $(this);
    if($this.attr('href').split('#')[0] == location.href.split('#')[0]){
      const targetAnchor = $this.attr('href').split('#')[1];
      if(targetAnchor){
        event.preventDefault();
        mycom.closeMenu();
        mycom.anchorTo(targetAnchor);
      }
    }
  })


}
mycom.initAnchorlink();


const menuIcon = document.querySelector('.js-menu-icon'),
      menuBody = document.querySelector('.l-menu'),
      //menuOverlay = document.querySelector('.js-menu-overlay'),
      menuContent = document.querySelector('.l-nav__content');

mycom.initMenu = function(){
  mycom.openMenu = function(){
    mycom.body.classList.add('is-menu-open')
    //menuBody.style.display = 'block';
    menuContent.style.opacity = 0;

    $(menuBody).velocity('fadeIn', {
      duration: 300,
      easing: 'easeOutQuad',
      begin: ()=> {
        setTimeout(()=> {
          $(menuContent).velocity({
            translateY: [0, 20],
            opacity: 1
          }, {
            duration: 600,
            easing: 'easeOutCubic',
          })
        }, 200);
      }
    })
  }

  /*
    メニューは左から入って右に抜ける動き
  */

  mycom.closeMenu = function(){

    $.Velocity(menuContent, {
      opacity: 0
    }, {
      duration: 200,
      easing: 'easeOutQuad',
      begin: ()=> {
        
        setTimeout(()=> {
          $(menuBody).velocity('fadeOut', {
            duration: 400,
            easing: 'easeOutQuad',
          })
        }, 100);
      }, 
      complete: ()=> {
        mycom.body.classList.remove('is-menu-open')
      }
    })
  }

  menuIcon.addEventListener('click', ()=> {
    if(!mycom.body.classList.contains('is-menu-open')){
      //mycom.body.classList.add('is-menu-open')
      mycom.openMenu();
    } else {
      //mycom.body.classList.remove('is-menu-open')
      mycom.closeMenu();
    }
  });

}
mycom.initMenu();


mycom.initModalSlider = function(){
  console.log('modalslider');

  /**
   * ギャラリーに対応するモーダルのスライダー
   *
   * ギャラリーがあればモーダルのHTMLを作って差し込む 
   * ギャラリーのリンクをクリックすると、対応するモーダルの対応するスライドが開く
   */
  /*
   <div class="l-modal__content">
    <div class="l-modal__content-inner">
      <div class="c-modalslider">
        <div class="swiper-container c-modalslider__main">
          <div class="swiper-wrapper">
            <div class="c-modalslider__item swiper-slide"><figure><img loading="lazy" width="1280" height="1810" src="//localhost:3000/wp-content/uploads/2021/06/201003.jpg" alt="" data-id="49" data-full-url="//localhost:3000/wp-content/uploads/2021/06/201003.jpg" data-link="//localhost:3000/projects/%e3%83%80%e3%83%9f%e3%83%bc/attachment/201003/" class="wp-image-49" srcset="//localhost:3000/wp-content/uploads/2021/06/201003.jpg 1280w, //localhost:3000/wp-content/uploads/2021/06/201003-212x300.jpg 212w, //localhost:3000/wp-content/uploads/2021/06/201003-724x1024.jpg 724w, //localhost:3000/wp-content/uploads/2021/06/201003-768x1086.jpg 768w, //localhost:3000/wp-content/uploads/2021/06/201003-1086x1536.jpg 1086w" sizes="(max-width: 1280px) 100vw, 1280px"></figure></div>
          </div>
        </div>
        <div class="c-modalslider__button c-modalslider__button--prev swiper-button-prev"></div>
        <div class="c-modalslider__button c-modalslider__button--next swiper-button-next"></div>
      </div>
    </div>
  </div>
  */

  const sliderOpenHTML = '<div class="l-modal__content">' +
                            '<div class="l-modal__content-inner">' +
                              '<div class="c-modalslider">' +
                                '<div class="swiper-container c-modalslider__main">' +
                                  '<div class="swiper-wrapper">';

  const sliderCloseHTML =         '</div>'+
                                '</div>'+
                                '<div class="c-modalslider__button c-modalslider__button--prev swiper-button-prev"></div>'+
                                '<div class="c-modalslider__button c-modalslider__button--next swiper-button-next"></div>'+
                              '</div>'+
                            '</div>'+
                          '</div>';

  

  const $modal = $('.l-modal'),
        $modalOverlay = $('.l-modal__overlay'),
        $modalClose = $('.l-modal__close'),
        $modalElementarea = $('#modalelement');

  //ギャラリーに対応したモーダルを差し込む
  //ギャラリーごとのHTMLを取得
  let galleryHTML = '';

  $('.wp-block-gallery').each(function(galleryIndex){
    
    const $thisGallery = $(this);

    galleryHTML += sliderOpenHTML;
    $('.blocks-gallery-item', $thisGallery).each(function(){

      const $thisItem = $(this);

      const $thisImgElem = $('img',$thisItem);
      let imgElem = $('<div>');
      imgElem.append($thisImgElem.clone(true));
      //console.log(typeof thisImgElem);
      
      galleryHTML += '<div class="c-modalslider__item swiper-slide"><figure>'+imgElem.html()+'</figure></div>';
      //console.log(galleryHTML);
    })
    galleryHTML += sliderCloseHTML;

    //console.log(galleryHTML);

  })
  $modalElementarea.replaceWith(galleryHTML);
  
  
  
  //HTMLに差し込む

  $('.wp-block-gallery').each(function(galleryIndex){

    const $thisGallery = $(this);


    //クリックするとモーダルを開く
    $('.blocks-gallery-item', $thisGallery).each(function(itemIndex){
      const $thisItem = $(this);
      $('a', $thisItem).on('click', function(evnet){
        evnet.preventDefault(); 
        //対応するモーダルを開く
          //対応するスライドでスライダーをinit
        if(!$('body').hasClass('is-slidemodal-open')){
          openSliderModal(galleryIndex, itemIndex);
        }
      })

    })
    
  })

  $modalClose.on('click', ()=> {
    closeSliderModal();
  })

  //モーダルスライダーを閉じるときにdestroy

  function openSliderModal(tagetModalIndex, targetSlideIndex){
    $('body').addClass('is-slidemodal-open');
    console.log(tagetModalIndex, targetSlideIndex)
    $modal.velocity('fadeIn', {
      duration: 300,
      easing: 'easeOutQuad',
      begin: ()=> {
        
        //対応するcontentをdisplay:block
        $('.l-modal__content').eq(tagetModalIndex).css({'opacity': 0}).show()
        
        setTimeout(()=> {
          
          //swiper
          initSlider(tagetModalIndex, targetSlideIndex)
          $('.l-modal__content').eq(tagetModalIndex).css({'opacity': 1})

        }, 20);
      }
    })

  }

  function closeSliderModal(){
    console.log('close')
    $modal.velocity('fadeOut', {
      duration: 200,
      easing: 'easeOutQuad',
      complete: ()=> {
        //contentをdisplay:none;
        $('.l-modal__content').hide();
        $('body').removeClass('is-slidemodal-open');
      }
    })
  }

  function initSlider(tagetModalIndex, targetSlideIndex){
    console.log('init slider', targetSlideIndex);

    const targetSliderElem = $('.l-modal__content').eq(tagetModalIndex).find('.c-modalslider__main'),
          targetSliderNextBtn = $('.l-modal__content').eq(tagetModalIndex).find('.c-modalslider__button--next'),
          targetSliderPrevBtn = $('.l-modal__content').eq(tagetModalIndex).find('.c-modalslider__button--prev');
    console.log(targetSliderElem);

    const modalSlider = new Swiper(targetSliderElem, {
      initialSlide: targetSlideIndex,
      navigation: {
        nextEl: targetSliderNextBtn,
        prevEl: targetSliderPrevBtn,
      },
    })

  }



  

  //$('.l-modal__content')

}
window.addEventListener('DOMContentLoaded', ()=> {
  //mycom.initModalSlider();
})


mycom.initScrollFunc = ()=> {
  const header = document.querySelector('.siteheader'),
        footer = document.querySelector('.sitefooter');

  let scrolledOffset;

  if(window.innerWidth > mycom.breakPoint){
    scrolledOffset = 50;
  } else {
    scrolledOffset = 50;
  }

  let currentPos = window.pageYOffset;

  function scrollFunc() {
    currentPos = window.pageYOffset;

    if(currentPos > scrolledOffset){
      if(!mycom.body.classList.contains('is-scrolled')){
        mycom.body.classList.add('is-scrolled');
      }
    } else {
      if(mycom.body.classList.contains('is-scrolled')){
        mycom.body.classList.remove('is-scrolled')
      }
    }

    if(currentPos > $(footer).offset().top - window.innerHeight){
      if(!mycom.body.classList.contains('is-footer-visible')){
        mycom.body.classList.add('is-footer-visible')
      }
    } else {
      if(mycom.body.classList.contains('is-footer-visible')){
        mycom.body.classList.remove('is-footer-visible')
      }
    }


    if(currentPos > $(footer).offset().top - window.innerHeight / 2){
      if(!mycom.body.classList.contains('is-footer-half-visible')){
        mycom.body.classList.add('is-footer-half-visible')
      }
    } else {
      if(mycom.body.classList.contains('is-footer-half-visible')){
        mycom.body.classList.remove('is-footer-half-visible')
      }
    }

  }
  scrollFunc()

   window.addEventListener('scroll', ()=> {
    scrollFunc()
  })

  window.addEventListener('resize', ()=> {
    if(window.innerWidth > mycom.breakPoint){
      scrolledOffset = 50;
    } else {
      scrolledOffset = 50;
    }
  })

}
//mycom.initScrollFunc();



mycom.initNavigations = ()=> {

  //カレント表示用に、barba-containerに data-type 属性を追加している。
  const currentPostType = mycom.container.dataset.type,
        headerNavLinkElemArray = mycom.headerNav.querySelectorAll('a');

  for(let i = 0; i < headerNavLinkElemArray.length; i++){
    const thisLink = headerNavLinkElemArray[i];
    thisLink.classList.remove('is-current');

    let thisText = thisLink.href.split('/');
    //console.log()
    thisText = thisText[thisText.length - 2];

    //console.log(thisText)
    //thisText = thisText.replace(/\s+/g, '-');

    if(currentPostType.indexOf(thisText) > -1){
      thisLink.classList.add('is-current')
    }
  }
}
window.addEventListener('DOMContentLoaded', ()=> {
  //mycom.initNavigations();
})



//
mycom.initHeroSlider = function(){

  const heroSliderElem = document.querySelector('.heroslider');

  if(heroSliderElem == null){
    return;
  }

  const animationSpeed = 1200,
        loopInterval = 4000;

  const heroSlider = new Swiper(heroSliderElem , {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    allowTouchMove: false,
    speed: animationSpeed,
    autoplay: {
      delay: loopInterval,
      disableOnInteraction: false
    }
  })


  $('.swiper-slide-active').addClass('is-kenburns');

  heroSlider.on('slideChangeTransitionStart', ()=> {

    //スライドが始まる時にis-kenburnsクラスを付与。ループ用に複製されたスライドにも同様
    $('.swiper-slide-active').addClass('is-kenburns');
    $('.swiper-slide-duplicate-active').addClass('is-kenburns');

    //activeでないスライドのis-kenburnsクラスを外す
    setTimeout(function(){
      $('.heroslider__item').not('.swiper-slide-active, .swiper-slide-duplicate-active').removeClass('is-kenburns');
    }, animationSpeed + 100);
  })
}

window.addEventListener('DOMContentLoaded', ()=> {
  mycom.initHeroSlider();
})

mycom.setPartsLayout = function(){
  
  //readmoreブロック
  $('.wp-block-group.readmore').each(function(){
    const $this = $(this);
    $this.prepend('<button class="readmore-toggle f-en">READ MORE</button>')
    const $thisToggle = $('.readmore-toggle', $this),
          $thisBody = $('.wp-block-group__inner-container', $this);
    
    $thisToggle.on('click', ()=> {
      //console.log('click');
      $thisToggle.velocity('slideUp', {
        duration: 300,
        easing: 'easeOutQuad'
      });
      
      if(!$this.hasClass('is-open')){
        $thisBody.velocity('slideDown', {
          duration: 300,
          easing: 'easeOutQuad',
          begin: ()=> {
            $this.addClass('is-open')
          },
          complete: ()=> {
            
          }
        })
      }
      
    })

  })
  
  if($('.c-datenav').length > 0){
    const $dateNav = $('.c-datenav'),
    scrollList = document.querySelector('.c-datenav__scrollcontainer ul');

    //矢印をクリックしたらローカルナビが横にスクロールする
    const $scrollContainer = $('.c-datenav__scrollcontainer'),
          $scrollElement = $('ul', $scrollContainer);

    let targetElementLeftPos,
        targetPos;
    
    const slideAmount = 100;
    $('.c-datenav__arrow').on('click', ()=> {

      targetElementLeftPos = $scrollContainer.scrollLeft()

      if(targetElementLeftPos > $scrollElement.innerWidth() - $scrollContainer.innerWidth() - 5) {
        //端に来ていたら最初に戻す
        //スクロール量が、スクロールエレメントが表示領域からはみ出ている量 = スクロールできる量 - 5 より大きければ最初に戻す
        targetPos = 0;
      } else if(targetElementLeftPos + slideAmount > $scrollElement.innerWidth() - $scrollContainer.innerWidth() - 50){
        //移動後の残りスクロール量が50px以下になるなら最後まで動かす
        //console.log($scrollElement.innerWidth(), $scrollContainer.innerWidth(), targetElementLeftPos)
        targetPos = targetElementLeftPos + slideAmount + 50;
      } else {
        targetPos = targetElementLeftPos + slideAmount;  
      }

      $scrollContainer.animate({scrollLeft:targetPos}, 300, "swing");
      //console.log('-------------')

    })

    function checkDateNavOverflow(){
    scrollListFullWidth = scrollList.scrollWidth;
    if(scrollListFullWidth > $dateNav.width()){
      if(!$dateNav.hasClass('is-overflow')) {
        $dateNav.addClass('is-overflow')
      }
      
    } else {
      if($dateNav.hasClass('is-overflow')) {
        $dateNav.removeClass('is-overflow')
      }
    }
    }
    checkDateNavOverflow()

    $(window).on('resize', function(){
    checkDateNavOverflow()
    })
  }


  




  //ページの最低高さ
  /*
  mycom.wrapper.style.minHeight = window.innerHeight - mycom.footer.clientHeight + 'px';
  window.addEventListener('resize', ()=> {
    mycom.wrapper.style.minHeight = window.innerHeight - mycom.footer.clientHeight + 'px';
  })*/

}

window.addEventListener('DOMContentLoaded', ()=> {
  mycom.setPartsLayout();
});


mycom.initCarousel = function(){

  //PROJECTS ARCHIVE のスライダー
  if(document.querySelector('.c-projectsslider') !== null ) {

    const projectsSliderElem = document.querySelector('.c-projectsslider');

    const projectsSlider = new Swiper(projectsSliderElem, {
      speed: 1000,
      effect: 'fade',
      loop: true,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      }
    })
    projectsSlider.autoplay.stop();

    //スライダーはフェードインするのでautoplayのスタートを少し待つ
    setTimeout(function(){
      if(!projectsSlider.autoplay.runing){
        projectsSlider.autoplay.start();
      }
    }, 600);

    $('.js-projectslider-controller').each(function(){
      const $this = $(this);
      $('li', $this).eq(0).addClass('is-slideactive');
    })

    projectsSlider.on('activeIndexChange', function(){
      $('.js-projectslider-controller li').removeClass('is-slideactive');
      //$('.js-projectslider-controller li').eq().addClass('is-slideactive');

      $('.js-projectslider-controller').each(function(){
        const $this = $(this);
        $('li', $this).eq(projectsSlider.realIndex).addClass('is-slideactive');
      })

    })

    let currentSlideIndex = projectsSlider.realIndex;

    //フェードの終わりだけスピードを早くする
    //消えるスライドにクラスをつける
    projectsSlider.on('slideChangeTransitionStart', function(){
      $('.c-projectsslider__slide[data-swiper-slide-index="'+currentSlideIndex+'"]').addClass('is-leaving');
    });

    projectsSlider.on('slideChangeTransitionEnd', function(){
      $('.c-projectsslider__slide').removeClass('is-leaving');
      currentSlideIndex = projectsSlider.realIndex;
    });


    //サイドバーのナビにマウスオーバーしたらそのスライドに移動する
    //マウスが乗っている間はスライドしない
    //マウス外れて200ms待って自動スライドスタート、マウスが乗れば待ちを解除
    let slideStartTimer = false;
    $('.js-projectslider-controller li').each(function() {
      const $this = $(this);

      $('a', $this).mouseenter(()=> {
        const $targetSlideIndex = $this.index();
        
        clearTimeout(slideStartTimer);
        projectsSlider.autoplay.stop()
        projectsSlider.slideToLoop($targetSlideIndex);
        
      }).mouseleave(()=> {

        slideStartTimer = setTimeout(()=> {
          projectsSlider.autoplay.start()
        }, 200);

      })
    })

    //PCレイアウト時、スライダーの高さをサイドバーの高さ + サイドバーのトップからのオフセットにする
    function setSliderHeight(){
      const $pcNav = $('.l-nav__top');
      let sliderMinHeight = $pcNav.offset().top + $pcNav.innerHeight();
      if(window.innerWidth < mycom.breakPoint){
        sliderMinHeight = 0;
      }
      $('.c-projectsslider .swiper-wrapper').css({'min-height': sliderMinHeight + 'px'}); 
    }
    setSliderHeight();

    $(window).on('resize', function(){
      setSliderHeight();
    })

  }

}
mycom.initCarousel();


mycom.kazetorock = function(){
  //
  if(!$('body').hasClass('page-kazetorock-inc')) {
    return;
  }
  setTimeout(()=> {
    $(window).scrollTop(0)
    $('body').addClass('is-shown')
  }, 100);

  $('.l-kazetorock__loading img').delay(100).velocity({
    opacity: 1
  }, {
    duration: 1000,
    easing: 'easeInOutQuad',
    complete: ()=> {
      $('.l-kazetorock__loading img').delay(400).velocity({
        opacity: 0
      }, {
        duration: 1200,
        easing: 'easeInOutQuad',
        begin: ()=> {
          $('.l-kazetorock__loading').delay(600).velocity('fadeOut', {
            duration: 1200,
            easing: 'easeInOutQuad',
            complete: ()=> {
              $('body').addClass('is-loading-done');
            }
          })
        },
        
      })
    }
  })
}
window.addEventListener('DOMContentLoaded', ()=> {
  mycom.kazetorock();
})

window.addEventListener('DOMContentLoaded', ()=> {
  mycom.body.classList.add('is-ready')
})


